import React, { useState, useContext, useEffect } from 'react'
import AuditLogsService from '../../../../../../../services/api/audit-logs.service';
import { store } from '../../../../../../../context/StateProvider';
import DimLoader from '../../../../../../templates/components/DimLoader';
import AuditLogDiffViewer from './AuditLogDiffViewer';

const AuditLogsView = (props) => {
  const state = useContext(store).state
  const [isLoader, setIsLoader] = useState(true);
  const [auditLog, setAuditLog] = useState()

  const getAuditLogs = () => {
    setIsLoader(true)
    AuditLogsService.getAuditById(props.auditLogId).then(res => {
      //console.log(JSON.stringify(res))
      setAuditLog(res?.data)
      setIsLoader(false)
    }).catch(() => {
      setIsLoader(false)
    });
  }
  useEffect(() => {
    if (props?.auditLogId) {
      getAuditLogs();
    }
  }, [])
  return (
    <>
      {isLoader ? <DimLoader /> : <AuditLogDiffViewer auditLog={auditLog}/>}
      
    </>
  );
};

export default AuditLogsView;

